// extracted by mini-css-extract-plugin
export var avatarContainer = "_51-0";
export var avatarTypingWave = "_51-i";
export var gray = "_51-f";
export var green = "_51-c";
export var icon = "_51-9";
export var image = "_51-1";
export var lg = "_51-6";
export var md = "_51-5";
export var presenceDot = "_51-b";
export var red = "_51-d";
export var sm = "_51-4";
export var status = "_51-a";
export var typingDot = "_51-h";
export var typingPill = "_51-g";
export var xl = "_51-7";
export var xs = "_51-3";
export var xxl = "_51-8";
export var xxs = "_51-2";
export var yellow = "_51-e";